import { CalendarModal, FilterButton } from '@sympla/sympla-components';
import React, { useState } from 'react';
import { isMobile } from 'utils/misc';

interface DateFilterProps {
  label: string;
  value: string;
  onDateSelect: (keyword: string | null) => void;
}

export function DateFilter(props: DateFilterProps) {
  const { label, value, onDateSelect } = props;
  const [open, setOpen] = useState(false);

  const handleSelect = (item: { keyword: string; }) => {
    onDateSelect(item.keyword);
    setOpen(false);
  };

  const handleClear = () => {
    onDateSelect(null);
  };

  return (
    <>
      <FilterButton
        selectedItem={value}
        onClick={() => setOpen(true)}
        removeSelectedItem={handleClear}
        btnType="filter"
        upperCase={false}
      >
        {label}
      </FilterButton>
      <CalendarModal
        onSelect={handleSelect}
        open={open}
        accessibilityTitle="Data"
        title="Data"
        hideModal={() => setOpen(false)}
        isMobile={isMobile()}
      />
    </>
  );
}
